import styled from '@emotion/styled';
import Comment from '@engineering/icons/comment';
import Help from '@engineering/icons/help';
import { Button } from '@silvertours/front-shared';
import { HeaderIconStyles } from '../Header.styles';

const PhoneInfoPopoverWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const ContactIconButton = styled(Button)`
  padding: 0;
  background: none;

  :hover {
    background: none;
  }
`;

const ContactIcon = styled(Comment)`
  ${HeaderIconStyles};
  fill: ${({ theme }) => theme.colors.brand.green120};
  min-width: ${({ theme }) => theme.spacing[50]};
`;

/** The question mark icon of the floating header (index page variant). */
const HelpIcon = styled(Help)`
  ${HeaderIconStyles};
  fill: ${({ theme }) => theme.colors.brand.green120};
  min-width: ${({ theme }) => theme.spacing[50]};
`;

export { ContactIcon, HelpIcon, PhoneInfoPopoverWrapper, ContactIconButton };
